"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _interactionsActions = require("../../../../../website/modules/pages/actions/interactionsActions");

var _defaultPropertiesActions = require("../../actions/interactions/defaultPropertiesActions");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  current: (0, _immutable.Map)(),
  staged: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSiteSettingsActionTypes.SUCCESS, function (state, action) {
  var siteSettings = action.payload.data;
  var startingPoint = (0, _defineProperty2.default)({}, _constants.ALL_DOMAINS_KEY, siteSettings[_constants.OWNER_MERGE_TAG_DEFAULTS]);
  return state.merge({
    current: startingPoint,
    staged: startingPoint
  });
}), (0, _defineProperty2.default)(_handleActions, _defaultPropertiesActions.EmailDefaultPropertiesActionTypes.CHANGE_DEFAULT_EMAIL_OWNER_PROPERTY_VALUE, function (state, action) {
  var _action$payload = action.payload,
      value = _action$payload.value,
      selectedProperty = _action$payload.selectedProperty;
  return state.setIn(['staged', _constants.ALL_DOMAINS_KEY, selectedProperty], value);
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.CANCEL_CHANGE_PROPERTIES, function (state) {
  return state.set('staged', state.get('current'));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;